import { Modal, Button } from "react-bootstrap"

export default function ValidationGarantiaModal({ showModal,
    setShowModal,
    success,
    //validationTitle, 
    validationList,
    isAfterSave }) {
    return (
        <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            animation={false}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="z-indez-9999">
            <Modal.Header >
                <Modal.Title>{isAfterSave ? "Actualización/Validación de Garantía" : "Validación de Garantía"}</Modal.Title>
            </Modal.Header>
            {success ? (
                <Modal.Body>
                    {isAfterSave ?
                        <div className="alert alert-success" role="alert">
                            OK! Se procedió a guardar y validar la información registrada en la Garantía. Puede proceder con el envío a Revisión.
                        </div> :
                        <div className="alert alert-success" role="alert">
                            OK! Informacion de la Garantía validada. Puede proceder con el envío a Revisión.
                        </div>
                    }


                </Modal.Body>
            ) : (
                <Modal.Body>
                    {isAfterSave ?
                        <div className="alert alert-warning" role="alert">
                            Warning! Se procedió a guardar la información registrada en la Garantía. No obstante se encontraron
                            errores en el proceso de validación.
                        </div> :
                        <div className="alert alert-warning" role="alert">
                            Warning! Se encontraron errores en el proceso de validación.
                        </div>
                    }
                    {/* <h5 className="mb-6">{validationTitle}</h5> */}
                    <h5 className="mb-6">Errores encontrados</h5>
                    <ul className="list-group border">
                        {validationList.map((item, index) => (
                            <li key={index} className="list-group-item d-flex align-items-center">
                                <i className="fi fi-rr-triangle-warning me-3 text-warning"></i>
                                {item}
                            </li>
                        ))}
                    </ul>
                </Modal.Body>
            )}

            <Modal.Footer>
                <Button variant="secundary" onClick={() => setShowModal(false)}>Cerrar</Button>
            </Modal.Footer>
        </Modal>
    )
}